import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  IconButton,
  CircularProgress,
  Divider,
  alpha,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import HistoryIcon from "@mui/icons-material/History";
import SendIcon from "@mui/icons-material/Send";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import ListIcon from "@mui/icons-material/List";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorIcon from "@mui/icons-material/Error";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";

// import {
//   ArrowBack,
//   ArrowForward,
//   ContentCopy,
//   History,
//   Send,
//   Mood,
//   MoodBad,
//   List,
//   AccessTime,
//   Error
// } from '@mui/icons-material';
import CryptoJS from "crypto-js";
import moment from "moment";
import {
  CHATSECRETKEY,
  P2PWEBSERVICE,
  WEBSERVICE,
} from "../../CoreDataService";
import { useChat } from "../../Services/ChatService";
import { useSelector } from "react-redux";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const P2pAppealProgressStatus = () => {
  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
  } = useChat(); // Access state and methods
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");

  const [state, setState] = useState({
    stpLoader: false,
    themeColor: localStorage.getItem("themecolor") || "Dark",
    step: 1,
    myUuid: localStorage.getItem("uuid"),
    counterPartyUUid: localStorage.getItem("counterPartyUuid"),
    orderId: localStorage.getItem("previousOrderId"),
    adId: localStorage.getItem("previousAdId"),
    chatUserName: localStorage.getItem("chatUserName"),
    secretKey: CHATSECRETKEY,
    imageLink: "./assets/img/default.png",
    p2pMessages: [],
    p2pPreviousMessage: [],
    groupChatUserList: [],
    currentDateTime: "",
    messageText: "",
    online: null,
    onlineUsersList: [],
    userOnline: false,
    appealCreatedTime: localStorage.getItem("appealCreationTime"),
    counter: 3600,
    emptyCounter: false,
    updateAppealExecuted: false,
    getAppealStatusExecuted: false,
    appealStatus: "",
    appealCreatedOn: "",
    appealStatusText: localStorage.getItem("appeal-step-text") || "",
    myAppealList: [],
    appealAgainstMeList: [],
    profilePic: localStorage.getItem("profilePic"),
    profileImageLink: localStorage.getItem("profileImageLink"),
    firstLetter: localStorage.getItem("firstLetter"),
    activeTab: "myAppeal",
    p2pPreviousMessage: [],
  });

  useEffect(() => {
    // Initialize component
    const startDate = new Date(state.appealCreatedTime);
    const endDate = new Date();
    const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    setState((prev) => ({ ...prev, counter: 3600 - seconds }));

    // Start countdown timer
    const timer = setInterval(() => {
      setState((prev) => {
        if (prev.counter <= 0) {
          clearInterval(timer);
          return { ...prev, counter: 0 };
        }
        return { ...prev, counter: prev.counter - 1 };
      });
    }, 1000);

    // Get initial data
    getAppealStatus();
    appealHistoryList();
    createTraderChat();
    getPreviousChatData();

    // Set profile image
    // if (localStorage.getItem('profile_pic')) {
    //   setState(prev => ({ ...prev, imageLink: bodyService.profilePic || './assets/img/default.png' }));
    // }

    // Schedule status check every 5 minutes
    const statusCheckInterval = setInterval(() => {
      getAppealStatus();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(timer);
      clearInterval(statusCheckInterval);
    };
  }, []);

  useEffect(() => {
    // Check counter and update appeal status if needed
    if (
      state.counter <= 0 &&
      !state.emptyCounter &&
      !state.updateAppealExecuted &&
      !state.getAppealStatusExecuted
    ) {
      if (!state.getAppealStatusExecuted) {
        getAppealStatus();
        setState((prev) => ({ ...prev, getAppealStatusExecuted: true }));
      }

      if (state.appealStatus === 0 && !state.updateAppealExecuted) {
        updateAppeal(2);
        setState((prev) => ({
          ...prev,
          updateAppealExecuted: true,
          emptyCounter: true,
        }));
      }
    }
  }, [
    state.counter,
    state.emptyCounter,
    state.updateAppealExecuted,
    state.getAppealStatusExecuted,
    state.appealStatus,
  ]);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    }, 3000);
  };

  const scrollToBottomFast = () => {
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    }, 500);
  };

  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();
    const currentSecond = currentDate.getSeconds();
    setState((prev) => ({
      ...prev,
      currentDateTime: `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`,
    }));
  };

  const getPreviousChatData = () => {
    const jsonObj = {
      groupId: parseInt(state.orderId),
      pageNo: 1,
      pageSize: 100,
      fromUserUuid: state.myUuid,
    };

    fetch(`${WEBSERVICE}user/getP2pChatMessages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + localStorage.getItem("access_token"),
      },
      body: JSON.stringify(jsonObj),
    })
      .then((response) => response.json())
      .then((data) => {
        // Ensure we always have an array, even if data is null/undefined
        const messages = Array.isArray(data.chatMessageList)
          ? data.chatMessageList.reverse()
          : [];
        const groupUsers = Array.isArray(data.groupChatUserList)
          ? data.groupChatUserList
          : [];

        setState((prev) => ({
          ...prev,
          groupChatUserList: groupUsers,
          p2pPreviousMessage: messages.map((message) => {
            const matchingUser = groupUsers.find(
              (user) => user.userUuid === message.fromuser
            );
            return {
              ...message,
              username: matchingUser ? matchingUser.userName : "",
            };
          }),
        }));
        scrollToBottom();
      });
  };

  // In the sendMessageToTrader function, ensure we're spreading an array
  const sendMessageToTrader = () => {
    if (!state.messageText || state.messageText.trim() === "") {
      // Show error alert
      return;
    }

    const dateToday = moment(new Date()).format(" DD MMMM YYYY");
    const b64 = CryptoJS.AES.encrypt(
      state.messageText,
      state.secretKey.trim()
    ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const encryptData = e64.toString(CryptoJS.enc.Hex);

    const messageData = {
      date: dateToday,
      user: state.myUuid,
      id: 1,
      message: encryptData,
      status: 1,
      time: new Date().toLocaleTimeString(),
      group: parseInt(state.orderId),
    };

    // Assuming chatService has a method to send messages
    sendMessageToUser("sendp2pmessage", messageData);

    // chatService.sendMessageToUser('sendp2pmessage', messageData);

    setState((prev) => ({
      ...prev,
      messageText: "",
      p2pPreviousMessage: [
        ...(Array.isArray(prev.p2pPreviousMessage)
          ? prev.p2pPreviousMessage
          : []),
        {
          message: encryptData,
          date: dateToday,
          time: messageData.time,
          fromuser: state.myUuid,
          matched: "false",
          username: state.chatUserName,
        },
      ],
    }));

    scrollToBottomFast();
  };

  const createTraderChat = () => {
    const inputObj = {
      groupId: parseInt(state.orderId),
      groupChatUsers: [
        { userUuid: state.myUuid, userType: "TRADER" },
        { userUuid: state.counterPartyUUid, userType: "TRADER" },
      ],
      fromUserUuid: state.myUuid,
    };

    fetch(`${WEBSERVICE}user/createP2pChat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + localStorage.getItem("access_token"),
      },
      body: JSON.stringify(inputObj),
    }).then(() => getPreviousChatData());
  };

  const decryptMessages = (message) => {
    try {
      const reb64 = CryptoJS.enc.Hex.parse(message);
      const bytes = reb64.toString(CryptoJS.enc.Base64);
      const decrypt = CryptoJS.AES.decrypt(bytes, state.secretKey);
      return decrypt.toString(CryptoJS.enc.Utf8);
    } catch {
      return message;
    }
  };

  const getAppealStatus = () => {
    setState((prev) => ({ ...prev, stpLoader: true }));

    const jsonObj = { orderId: Number(state.orderId) };

    fetch(`${P2PWEBSERVICE}/getAppealStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + localStorage.getItem("access_token"),
      },
      body: JSON.stringify(jsonObj),
    })
      .then((response) => response.json())
      .then((data) => {
        setState((prev) => ({ ...prev, stpLoader: false }));

        if (data.error.error_data === 0) {
          const status = data.appealStatus;
          let step = 1;
          let stepText = "Appeal Pending";

          if (status === "APPEAL SUBMITTED") {
            step = 2;
            stepText = "Appeal Pending";
          } else if (status === "CS REVIEW") {
            step = 3;
            stepText = "Appeal sent to CS";
          } else if (status === "APPEAL COMPLETED") {
            step = 4;
            stepText = "Appeal Completed";
          } else if (status === "APPEAL CANCELLED") {
            step = 0;
            stepText = "Appeal Got Cancelled";
          }

          localStorage.setItem("appeal-step", step.toString());
          localStorage.setItem("appeal-step-text", stepText);

          setState((prev) => ({
            ...prev,
            appealStatus: status,
            appealCreatedOn: data.appealCreatedOn,
            step: step,
            appealStatusText: stepText,
          }));
        }
      });
  };

  const appealHistoryList = () => {
    getAppealHistory(0);
  };

  const getAppealHistory = (flag) => {
    setState((prev) => ({ ...prev, stpLoader: true }));

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      flag: Number(flag),
    };

    fetch(`${P2PWEBSERVICE}/getAppealHistory`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + localStorage.getItem("access_token"),
      },
      body: JSON.stringify(jsonObj),
    })
      .then((response) => response.json())
      .then((data) => {
        setState((prev) => ({ ...prev, stpLoader: false }));

        if (data.error.error_data === 0) {
          if (flag === 0) {
            setState((prev) => ({
              ...prev,
              myAppealList: data.appealHistory || [],
            }));
          } else if (flag === 1) {
            setState((prev) => ({
              ...prev,
              appealAgainstMeList: data.appealHistory || [],
            }));
          }

          const nextFlag = flag + 1;
          if (nextFlag <= 1) {
            getAppealHistory(nextFlag);
          }
        }
      });
  };

  const updateAppeal = (status) => {
    setState((prev) => ({ ...prev, stpLoader: true }));

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      orderId: Number(state.orderId),
      appealStatusId: Number(status),
    };

    fetch(`${P2PWEBSERVICE}/updateAppeal`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + localStorage.getItem("access_token"),
      },
      body: JSON.stringify(jsonObj),
    })
      .then((response) => response.json())
      .then((data) => {
        setState((prev) => ({ ...prev, stpLoader: false }));

        if (data.error.error_data === 0) {
          let step = state.step;
          let stepText = state.appealStatusText;

          if (status === 1) {
            stepText = "Appeal Cancelled";
            step = 0;
            setTimeout(() => navigate("/p2p/my-orders"), 1500);
          } else if (status === 2) {
            stepText = "Appeal sent to CS";
            step = 3;
          } else if (status === 3) {
            stepText = "Appeal Completed";
            step = 4;
          }

          localStorage.setItem("appeal-step", step.toString());
          localStorage.setItem("appeal-step-text", stepText);

          setState((prev) => ({
            ...prev,
            step,
            appealStatusText: stepText,
          }));
        }
      });
  };

  const goToOrderDetails = (order, isMyAppeal) => {
    localStorage.setItem("previousAdId", order.adId);
    localStorage.setItem("previousOrderId", order.orderId);
    localStorage.setItem("orderCreationTime", order.orderDate);
    localStorage.setItem("counterPartyUuid", order.userUuid);
    localStorage.setItem("chatUserName", order.counterPartyName);
    localStorage.setItem("orderfiat", order.fiat);
    localStorage.setItem("orderCrypto", order.coin);

    if (order.orderType === "buy" || order.orderType === "BUY") {
      localStorage.setItem("previousPageBuyAmount", order.cryptoAmount);
      localStorage.setItem("previousPageBuyprice", order.price);
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);
      navigate("/p2p/order-details");
    } else {
      localStorage.setItem("previousPageBuyprice", order.cryptoAmount);
      localStorage.setItem("previousPageBuyAmount", order.price);
      localStorage.setItem("previousPageBuyTotalAmount", order.totalFiatPrice);
      navigate("/p2p/sell-order-details");
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(state.orderId)
      .then(() => {
        // Show success alert
      })
      .catch(() => {
        // Show error alert
      });
  };

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${h.toString().padStart(2, "0")}:${m
      .toString()
      .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const handleTabChange = (event, newValue) => {
    setState((prev) => ({ ...prev, activeTab: newValue }));
  };

  const handlePrevious = () => {
    if (state.step > 1 && state.step <= 4) {
      setState((prev) => ({ ...prev, step: prev.step - 1 }));
    }
  };

  const handleNext = () => {
    if (state.step >= 1 && state.step <= 3) {
      setState((prev) => ({ ...prev, step: prev.step + 1 }));
    }
  };

  const renderStepContent = () => {
    switch (state.step) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      case 0:
        return renderCancelled();
      default:
        return renderStep1();
    }
  };

  const renderStep1 = () => (
    <Box>
      <Typography variant="h6" sx={{ color: "var(--text-color)", mb: 1 }}>
        Appeal Submitted
      </Typography>
      {!state.emptyCounter && (
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            Pending response from respondent. Time remaining:
          </Typography>
          <Typography variant="h6" ml={1} sx={{ color: "var(--text-color)" }}>
            {formatTime(state.counter)}
          </Typography>
        </Box>
      )}

      <Box mb={3}>
        <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
          1. If both parties have reached an agreement, you can cancel the
          appeal and proceed to complete the trade.
        </Typography>
        <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
          2. CS is handling the case, please make sure you are accessible via
          the registered email and phone number.
        </Typography>
        <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
          3. For more information, please provide more info. Info provided by
          both user and CS can be found in appeal progress.
        </Typography>
      </Box>

      <ContainedButton
        variant="contained"
        onClick={() => updateAppeal(1)}
        disabled
      >
        Cancel the appeal
      </ContainedButton>

      {renderAppealHistory()}
    </Box>
  );

  const renderStep2 = () => (
    <Box display="flex" flexDirection="row" flexWrap="wrap">
      <Box flex={1} minWidth={500} pr={2}>
        {!state.emptyCounter && (
          <Box display="flex" alignItems="center" mb={2}>
            <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
              Please respond to the appeal within:
            </Typography>
            <Typography variant="h6" ml={1} sx={{ color: "var(--text-color)" }}>
              {formatTime(state.counter)}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: "rgba(245,158,11,0.08)",
            border: "1px solid rgba(245,158,11,0.2)",
            borderRadius: "10px",
          }}
        >
          <Box display="flex" alignItems="center">
            <ErrorIcon color="warning" />
            <Typography variant="body1" ml={1} sx={{ color: "var(--text-color)", opacity: 0.85 }}>
              The seller filed an appeal claiming that the payment is not
              received in the seller's account. If you have not paid, you can
              cancel the order. After cancellation, the appeal will end
              automatically.
            </Typography>
          </Box>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            1. If an agreement has been reached, please click "Consensus
            Reached". Once confirmed, the appeal will be canceled.
          </Typography>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            2. If you cannot reach an agreement with the other party, please
            click "Negotiation Failed", CS will get involved and attribute.
          </Typography>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            3. If the respondent did not respond within the time limit, our CS
            will get involved and arbitrate.
          </Typography>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            4. For more information, please provide more info. Info provided by
            both user and CS can be found in appeal progress.
          </Typography>
        </Box>

        <Typography variant="h6" sx={{ color: "var(--text-color)" }}>
          Negotiation Result
        </Typography>
        <Box display="flex" justifyContent="center" mt={2} gap={2}>
          <Button
            variant="contained"
            color="error"
            startIcon={<SentimentSatisfiedIcon />}
            onClick={() => updateAppeal(2)}
          >
            Negotiation failed
          </Button>
          <ContainedButton
            variant="contained"
            color="success"
            startIcon={<SentimentVerySatisfiedIcon />}
            onClick={() => updateAppeal(3)}
          >
            Consensus reached
          </ContainedButton>
        </Box>

        {renderAppealHistory()}
      </Box>

      <Box width={400}>{renderChatBox()}</Box>
    </Box>
  );

  const renderStep3 = () => (
    <Box display="flex" flexDirection="row" flexWrap="wrap">
      <Box flex={1} minWidth={500} pr={2}>
        <Typography variant="h6" mb={2} sx={{ color: "var(--text-color)" }}>
          Please wait for p2p customer support's assistance
        </Typography>

        <Box
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: "rgba(245,158,11,0.08)",
            border: "1px solid rgba(245,158,11,0.2)",
            borderRadius: "10px",
          }}
        >
          <Box display="flex" alignItems="center">
            <ErrorIcon color="warning" />
            <Typography variant="body1" ml={1} sx={{ color: "var(--text-color)", opacity: 0.85 }}>
              Your case is currently under investigation. As we are experiencing
              a high volume of inquires globally, your patience is appreciated.
              It can take 4-8 hours for our CS team to review your appeal.
            </Typography>
          </Box>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            1. If both parties have reached an agreement, you can appeal and
            proceed to complete the trade.
          </Typography>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            2. CS is handling the case, please make sure you are accessible via
            the registered email and phone.
          </Typography>
          <Typography variant="body1" sx={{ color: "var(--text-color)", opacity: 0.85 }}>
            3. For more information, please provide more info. Info provided by
            both user and CS can be found in appeal progress.
          </Typography>
        </Box>

        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => updateAppeal(1)}
            disabled
          >
            Cancel the appeal
          </Button>
        </Box>

        {renderAppealHistory()}
      </Box>

      <Box width={400}>{renderChatBox()}</Box>
    </Box>
  );

  const renderStep4 = () => (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Typography variant="h6" sx={{ color: "var(--text-color)" }}>
          Issue Resolved !!! . Hence appeal completed
        </Typography>
        <SentimentVerySatisfiedIcon
          color="success"
          sx={{ fontSize: 45, ml: 1 }}
        />
      </Box>

      {renderAppealHistory()}
    </Box>
  );

  const renderCancelled = () => (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography variant="h4" sx={{ color: "var(--text-color)" }}>
          {state.appealStatusText}
        </Typography>
        <SentimentSatisfiedIcon color="error" sx={{ fontSize: 45, ml: 1 }} />
      </Box>

      {renderAppealHistory()}
    </Box>
  );

  const renderAppealHistory = () => (
    <Box mt={4}>
      <Box display="flex" alignItems="center" mb={2}>
        <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-color)", mb: 2 }}>
          Appeal History
        </Typography>
        <IconButton onClick={appealHistoryList} sx={{ ml: 1, color: "var(--text-color)" }}>
          <HistoryIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          backgroundColor: "var(--body-color-less)",
          borderRadius: "12px",
          border: "1px solid rgba(125,125,125,0.15)",
          overflow: "hidden",
          mt: 2,
        }}
      >
        <Tabs
          value={state.activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            backgroundColor: "var(--body-color-less2)",
            "& .MuiTabs-indicator": { backgroundColor: btncolor },
            "& .MuiTab-root": {
              color: "var(--text-color)",
              opacity: 0.65,
              fontWeight: 600,
              fontSize: "0.82rem",
              textTransform: "none",
              "&.Mui-selected": { color: btncolor, opacity: 1 },
            },
          }}
        >
          <Tab
            label={`Appeal Created by me (${state.myAppealList.length})`}
            value="myAppeal"
          />
          <Tab
            label={`Appeal against me (${state.appealAgainstMeList.length})`}
            value="appealAgainstMe"
          />
        </Tabs>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        {state.activeTab === "myAppeal" ? (
          state.myAppealList.length === 0 ? (
            <Box sx={{ py: 6, textAlign: "center" }}>
              <Typography sx={{ color: "var(--text-color)", opacity: 0.5 }}>
                No Appeal Created By Me !!
              </Typography>
            </Box>
          ) : (
            <TableContainer sx={{ backgroundColor: "var(--body-color-less)" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "var(--body-color-less2)" }}>
                    <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Order Id</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Reason</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Created On</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Status</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state?.myAppealList?.map((appeal, index) => (
                    <TableRow key={index}>
                      <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>{appeal.orderId}</TableCell>
                      <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                        {appeal.appealReasonDetails}
                      </TableCell>
                      <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                        {appeal.appealCreated}
                      </TableCell>
                      <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                        {appeal.appealStatus}
                      </TableCell>
                      <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                        <IconButton
                          onClick={() => goToOrderDetails(appeal, true)}
                          sx={{ color: "var(--text-color)" }}
                        >
                          <ListIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : state.appealAgainstMeList.length === 0 ? (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <Typography sx={{ color: "var(--text-color)", opacity: 0.5 }}>
              No Appeal Against Me !!!
            </Typography>
          </Box>
        ) : (
          <TableContainer sx={{ backgroundColor: "var(--body-color-less)" }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "var(--body-color-less2)" }}>
                  <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Order Id</TableCell>
                  <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Reason</TableCell>
                  <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Created On</TableCell>
                  <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Status</TableCell>
                  <TableCell align="center" sx={{ color: "var(--text-color)", opacity: 0.6, fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase", borderBottom: "1px solid rgba(125,125,125,0.15)" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state?.appealAgainstMeList?.map((appeal, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>{appeal.orderId}</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                      {appeal.appealReasonDetails}
                    </TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>{appeal.appealCreated}</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>{appeal.appealStatus}</TableCell>
                    <TableCell align="center" sx={{ color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)", fontSize: "0.85rem" }}>
                      <IconButton
                        onClick={() => goToOrderDetails(appeal, false)}
                        sx={{ color: "var(--text-color)" }}
                      >
                        <ListIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );

  const renderChatBox = () => (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--body-color-less)",
        borderRadius: "12px",
        border: "1px solid rgba(125,125,125,0.12)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: "1px solid rgba(125,125,125,0.12)",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box position="relative">
          {state.profilePic === "null" ? (
            <Avatar sx={{ bgcolor: "primary.main" }}>
              {state.firstLetter}
            </Avatar>
          ) : (
            <Avatar src={state.profileImageLink} />
          )}
          <Box
            position="absolute"
            bottom={0}
            right={0}
            width={12}
            height={12}
            borderRadius="50%"
            bgcolor={state.userOnline ? "success.main" : "error.main"}
            border="2px solid white"
          />
        </Box>
        <Typography variant="h6" sx={{ color: "var(--text-color)" }}>
          {state.chatUserName}
        </Typography>
      </Box>

      <Box
        ref={scrollRef}
        flex={1}
        p={2}
        overflow="auto"
        sx={{ maxHeight: 600 }}
      >
        {Array.isArray(state.p2pPreviousMessage) &&
          state.p2pPreviousMessage.map((message, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection={
                message.fromuser === state.myUuid ? "row-reverse" : "row"
              }
              alignItems="flex-start"
              mb={2}
            >
              <Box mr={1} ml={1}>
                {message.fromuser === state.myUuid ? (
                  <Avatar src={state.imageLink} />
                ) : state.profilePic === "null" ? (
                  <Avatar sx={{ bgcolor: "primary.main" }}>
                    {state.firstLetter}
                  </Avatar>
                ) : (
                  <Avatar src={state.profileImageLink} />
                )}
              </Box>
              <Box
                p={2}
                borderRadius={2}
                sx={{
                  bgcolor:
                    message.fromuser === state.myUuid
                      ? alpha(btncolor || "#1976d2", 0.15)
                      : "var(--body-color-less2)",
                  color: "var(--text-color)",
                }}
                maxWidth="70%"
              >
                <Typography variant="subtitle2">{message.username}</Typography>
                <Typography variant="body1">
                  {decryptMessages(message.message)}
                </Typography>
                <Typography variant="caption" display="block">
                  Sent at: {message.date}, {message.time}
                </Typography>
              </Box>
            </Box>
          ))}
      </Box>

      <Box sx={{ p: 2, borderTop: "1px solid rgba(125,125,125,0.12)" }}>
        <Box display="flex">
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Type a message..."
            value={state.messageText}
            onChange={(e) =>
              setState((prev) => ({ ...prev, messageText: e.target.value }))
            }
            onKeyPress={(e) => e.key === "Enter" && sendMessageToTrader()}
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "var(--body-color-less2)",
                color: "var(--text-color)",
                borderRadius: "8px",
              },
              "& .MuiInputBase-input": { color: "var(--text-color)" },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(125,125,125,0.2)",
              },
            }}
          />
          <IconButton
            color="primary"
            onClick={sendMessageToTrader}
            sx={{ ml: 1 }}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );

  const pageWrapper = {
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 3 },
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    minHeight: "calc(100vh - 64px)",
  };

  const mainCard = {
    backgroundColor: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid rgba(125,125,125,0.15)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
    overflow: "hidden",
    p: { xs: 2, md: 3 },
    mb: 3,
  };

  return (
    <Box sx={pageWrapper}>

      {/* ── Hero Banner ── */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          borderRadius: "18px",
          px: { xs: 3, md: 4 },
          py: { xs: 3, md: 3.5 },
          mb: 3,
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, position: "relative", zIndex: 1 }}>
          <Box
            sx={{
              width: 56, height: 56, borderRadius: "14px",
              display: "flex", alignItems: "center", justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.18)",
              border: "1px solid rgba(255,255,255,0.25)",
              backdropFilter: "blur(6px)", flexShrink: 0,
            }}
          >
            <GavelOutlinedIcon sx={{ fontSize: 30, color: "#fff" }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: { xs: "1.4rem", md: "1.7rem" }, fontWeight: 700, color: "#fff", lineHeight: 1.15, letterSpacing: "-0.015em" }}>
              Appeal Progress
            </Typography>
            <Typography sx={{ fontSize: { xs: "0.82rem", md: "0.9rem" }, color: "rgba(255,255,255,0.88)", mt: 0.5 }}>
              Track the status of your P2P trading appeal
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Content Card ── */}
      <Box sx={mainCard}>

        {/* Order info header row */}
        <Box
          sx={{
            p: 2,
            mb: 2.5,
            backgroundColor: "var(--body-color-less2)",
            borderRadius: "12px",
            border: "1px solid rgba(125,125,125,0.12)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="h5" sx={{ color: "var(--text-color)", fontWeight: 700 }}>
            Appeal Process
          </Typography>

          <Box display="flex" alignItems="center" gap={3}>
            <Box>
              <Typography variant="body2" sx={{ color: "var(--text-color)", opacity: 0.6, fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", mb: 0.25 }}>
                Order Number
              </Typography>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Typography variant="h6" sx={{ color: "var(--text-color)", fontWeight: 700, fontSize: "0.95rem" }}>
                  {state.orderId}
                </Typography>
                <IconButton
                  size="small"
                  onClick={copyToClipboard}
                  sx={{ color: "var(--text-color)", opacity: 0.6, "&:hover": { opacity: 1 } }}
                >
                  <ContentCopyIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Box>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ color: "var(--text-color)", opacity: 0.6, fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.05em", mb: 0.25 }}>
                Appeal Created
              </Typography>
              <Typography sx={{ color: "var(--text-color)", fontWeight: 600, fontSize: "0.9rem" }}>
                {state.appealCreatedOn}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Current status label */}
        <Box mb={3}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}>
            {state.step !== 0 ? (
              state.appealStatusText
            ) : (
              <Box display="flex" alignItems="center" component="span">
                {state.appealStatusText}
                <SentimentSatisfiedIcon color="error" sx={{ fontSize: 28, ml: 1 }} />
              </Box>
            )}
          </Typography>
        </Box>

        {/* ── Steps Progress Bar ── */}
        <Box mb={4}>
          <Box display="flex" justifyContent="center">
            <Box width="100%" maxWidth={800}>
              <Box display="flex" justifyContent="space-between" position="relative">
                <Box
                  position="absolute"
                  top="20px"
                  left="10%"
                  right="10%"
                  height={4}
                  sx={{ bgcolor: "rgba(125,125,125,0.2)", borderRadius: 2 }}
                  zIndex={0}
                />
                <Box
                  position="absolute"
                  top="20px"
                  left="10%"
                  height={4}
                  sx={{
                    width: `${Math.max(0, Math.min(100, ((state.step - 1) / 3) * 100))}%`,
                    bgcolor: btncolor || "primary.main",
                    borderRadius: 2,
                    transition: "width 0.4s ease",
                  }}
                  zIndex={0}
                />

                {[
                  { num: 1, label: "Appeal Submitted" },
                  { num: 2, label: "Negotiate" },
                  { num: 3, label: "CS Review" },
                  { num: 4, label: "Completed" },
                ].map(({ num, label }) => (
                  <Box
                    key={num}
                    position="relative"
                    zIndex={1}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{ flex: 1 }}
                  >
                    <Box
                      width={40}
                      height={40}
                      borderRadius="50%"
                      sx={{
                        bgcolor: state.step >= num ? btncolor || "primary.main" : "rgba(125,125,125,0.25)",
                        border: state.step >= num
                          ? `2px solid ${btncolor || "primary.main"}`
                          : "2px solid rgba(125,125,125,0.2)",
                        boxShadow: state.step >= num ? `0 0 0 4px ${alpha(btncolor || "#1976d2", 0.15)}` : "none",
                        transition: "all 0.3s ease",
                      }}
                      color="white"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      mb={1}
                    >
                      <Typography sx={{ fontWeight: 700, fontSize: "0.88rem", color: state.step >= num ? "#fff" : "var(--text-color)" }}>
                        {num}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      textAlign="center"
                      sx={{
                        color: "var(--text-color)",
                        opacity: state.step >= num ? 1 : 0.45,
                        fontWeight: state.step === num ? 700 : 500,
                        fontSize: "0.75rem",
                        maxWidth: 90,
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>

        {/* ── Step Content ── */}
        {state.stpLoader ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress sx={{ color: btncolor }} />
          </Box>
        ) : (
          renderStepContent()
        )}

        {state.step > 0 && state.step < 4 && (
          <Box display="flex" justifyContent="center" mt={4}>
            <OutlinedButton
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handlePrevious}
              disabled={state.step <= 1}
            >
              Back
            </OutlinedButton>
          </Box>
        )}

      </Box>{/* end mainCard */}
    </Box>
  );
};

export default P2pAppealProgressStatus;
